import { ListHelper } from '~/training/sequence/templates/translators/itemHelpers/ListHelper';
import {
  BULLET_LIST,
  CARD,
  CardDefinition,
  LayoutColumnsDefinition,
  LayoutListDefinition,
  LAYOUT_COLUMNS,
  LAYOUT_LIST,
  TEXT
} from '../items';
import { Translator } from '../Translator';
import { PhoneHelper } from './itemHelpers/PhoneHelper';
import { ItemOfType } from './itemHelpers/types';
import { translate } from './translate';
import { getEditorState } from '~/shell/Store';

export const SocialMedia13: Translator = sequence => {
  const columns = {
    type: LAYOUT_COLUMNS,
    id: `${sequence.id}-columns`,
    items: [],
    values: {}
  } as LayoutColumnsDefinition;

  let isPhone = false;
  const contentEditable = getEditorState().contentEditable;

  (sequence.items ?? []).forEach(item => {
    if (item.__typename === 'Phone') {
      isPhone = true;
    }
  });
  const root = translate(sequence, item => {
    switch (item.__typename) {
      case 'Phone':
        columns.items.push(
          PhoneHelper(
            item as ItemOfType<'Phone'>,
            sequence,
            sequence.personalization
          )
        );
        break;

      case 'List':
        columns.items.push({
          id: item.id,
          type: LAYOUT_LIST,
          values: {
            align: { _: 'center', lg: 'left' },
            height: { _: 'auto', lg: '100%' },
            padded: true
          },
          items: [
            {
              type: CARD,
              id: '1',
              values: {
                clearStyles: 'md',
                height: 'auto',
                width: 'auto'
              },
              items: [
                {
                  id: item.id,
                  type: LAYOUT_LIST,
                  values: { align: 'left', height: 'auto' },
                  items: [
                    ...(!isPhone || (!contentEditable && item.subtitle)
                      ? [
                          {
                            type: TEXT,
                            id: item.id + '_subtitle',
                            items: [],
                            values: {
                              value: item.subtitle,
                              variant: 'sub_heading',
                              icon: item.icon
                            }
                          }
                        ]
                      : []),
                    {
                      type: TEXT,
                      id: item.id + '_title',
                      items: [],
                      values: {
                        value: item.title,
                        variant: 'heading1'
                      }
                    },
                    {
                      type: BULLET_LIST,
                      id: item.id,
                      values: [],
                      items: ListHelper(item.items)
                    }
                  ]
                }
              ]
            } as CardDefinition
          ]
        } as LayoutListDefinition);
    }
    return null;
  });

  root.items.push(columns);
  return root;
};
